/**
 * React Flow component for the server-written `commentMarker` node.
 *
 * It renders nothing on purpose. The marker is a near-content-free projection
 * of a Liveblocks thread — it carries a hard-truncated preview of the first
 * message and nothing else — that exists so the agent sees comments on the
 * canvas read it already makes each turn; the pin layer draws pins from
 * ThreadMetadata, which never lags a webhook. Registering it is not optional
 * — React Flow falls back to its built-in `default` node for unregistered
 * types, which would put a white box with handles on the board for every
 * thread.
 */
export function CommentMarkerNode() {
  return null;
}

/**
 * Hide the server-written markers in a node list bound for React Flow.
 *
 * They are storage-only — the agent reads them with the board, the pin layer
 * draws the pins — and a node that renders nothing is one React Flow never
 * measures. Left visible, that unmeasured node pins `nodesInitialized` false
 * for the whole canvas, which silently kills every fitView: the fit-to-content
 * on open, the Recenter control, Cmd+1, and the capture page's framing.
 */
export function hideCommentMarkers<T extends { type?: string }>(
  nodes: T[],
): T[] {
  return nodes.map((n) =>
    n.type === "commentMarker" ? { ...n, hidden: true } : n,
  );
}
